// ASAWEB-864: screen every request (fetch + XHR) for a literal "/undefined"
// segment before any feature code can fire one. Installed once per bundle.
import { installGlobalUrlGuard } from '../../../../Foundation/ReactForms/Code/Scripts/React/fetchWithAuth.jsx';
installGlobalUrlGuard();

// Member Join
import memberJoin from '../../../../Feature/MemberJoin/code/Scripts/MemberJoin.js';